var getUserGroupRoles = function getUserGroupRoles(groupId, claims) {
  if (groupId && claims) {
    var _ref = claims || {},
        _ref$groups = _ref.groups,
        groups = _ref$groups === void 0 ? {} : _ref$groups;

    return groups[groupId] || [];
  }

  return [];
};

export default getUserGroupRoles;